import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import KeyIcon from "@mui/icons-material/Key";
import SecurityIcon from "@mui/icons-material/Security";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ChangePasswordModal from "../components/ChangePasswordModal";
import ModalWindow from "../components/modal/ModalWindow";
import SmlouvySection from "../components/SmlouvySection";
import { fetchCurrentCustomerDetails, fetchCustomerContracts } from "../services/userService";
import { handleApiError } from "../utils/errorHandler";

export default function UserPage() {
  // Stav pro ovládání viditelnosti modalu
  const [modalVisible, setModalVisible] = useState(false);
  // Stav, který určí, jaký obsah modalu se zobrazí (heslo, sms)
  const [modalContent, setModalContent] = useState("");
  const [fetchedUserDetails, setFetchedUserDetails] = useState(null);
  const [contracts, setContracts] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    async function loadUserDetails() {
      setError(null);
      const [result, contractsResult] = await Promise.all([fetchCurrentCustomerDetails(), fetchCustomerContracts()]);

      if (result.success) {
        setFetchedUserDetails(result.data);
      } else {
        setError(handleApiError(result));
      }
      if (contractsResult.success) setContracts(contractsResult.data);
      else setError(handleApiError(contractsResult));
      setLoading(false);
    }
    loadUserDetails();
  }, []);

  // Otevře modal pro změnu hesla
  const handlePasswordChange = () => {
    setModalContent("password");
    setModalVisible(true);
  };

  if (error) {
    throw new Response(error.message, { status: error.status });
  }

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", p: 2 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 2, textAlign: "center" }}>
        Informace o účtu
      </Typography>
      <Box
        sx={{
          width: "100%",
          maxWidth: 1100,
          margin: "0 auto",
          px: { xs: 2, sm: 3 },
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            maxWidth: 600,
            margin: "0 auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              textAlign: "center",
              gap: 1,
              mb: "2px",
            }}
          >
            <AccountCircleIcon color="primary" sx={{ display: "inline-block" }} />

            <Typography variant="h6" color="primary">
              Váš účet
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: 1,
              mb: 10,
            }}
          >
            <Typography variant="body1">
              <strong>Číslo odběratele:</strong>{" "}
              {fetchedUserDetails?.cisloOdberatele}
            </Typography>
            <Typography variant="body1">
              <strong>Název:</strong> {fetchedUserDetails?.nazev || "-"}
            </Typography>
            <Typography variant="body1">
              <strong>Adresa:</strong> {fetchedUserDetails?.adresa || "-"}
            </Typography>
            <Typography variant="body1">
              <strong>IČ:</strong> {fetchedUserDetails?.ic || "-"}
            </Typography>
            <Typography variant="body1">
              <strong>DIČ:</strong> {fetchedUserDetails?.dic || "-"}
            </Typography>
            <Typography variant="body1">
              <strong>Telefon:</strong> {fetchedUserDetails?.telefon || "-"}
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>E-mail:</strong> {fetchedUserDetails?.emailOrsoft || "-"}
            </Typography>
          </Box>
        </Box>
        <SmlouvySection contracts={contracts} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Tlačítka pro otevírání modalu */}
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Button endIcon={<KeyIcon />} onClick={handlePasswordChange}>
              Změna hesla
            </Button>
            <Button
              endIcon={<SecurityIcon />}
              onClick={() => navigate("/zvk/mfa-settings")}
            >
              Nastavení vícefaktorového ověření
            </Button>
          </Box>
        </Box>

        {/* Komponenta ModalWindow, do které vkládáme obsah podle modalContent */}
        <ModalWindow visible={modalVisible} setVisible={setModalVisible}>
          {modalContent === "password" && (
            <ChangePasswordModal setVisible={setModalVisible} />
          )}
        </ModalWindow>
      </Box>
    </Box>
  );
}
